function isLocalOrSessionStorage(): boolean {
  let result;
  if (getItemLocalStorage("isRemember")) {
    result = getItemLocalStorage("isRemember") === "true" ? true : false;
  } else {
    removeItemLocalStorage("user");
  }

  return result;
}

function getItemStorage(name: string): string {
  const result: string = isLocalOrSessionStorage()
    ? getItemLocalStorage(name)
    : getItemSessionStorage(name);
  return result;
}

function setItemStorage(name: string, value: string) {
  if (isLocalOrSessionStorage()) {
    setItemLocalStorage(name, value);
  } else {
    setItemSessionStorage(name, value);
  }
}

function getItemSessionStorage(name: string): string {
  const result: string = sessionStorage.getItem(
    btoa(encodeURIComponent(name))
  ) as string;
  return result ? decodeURIComponent(atob(result)) : result;
}

function setItemSessionStorage(name: string, value: string): void {
  sessionStorage.setItem(
    btoa(encodeURIComponent(name)),
    btoa(encodeURIComponent(value))
  );
}

function getItemLocalStorage(name: string): string {
  const result: string = window.localStorage.getItem(
    btoa(encodeURIComponent(name))
  ) as string;
  return result ? decodeURIComponent(atob(result)) : result;
}

function setItemLocalStorage(name: string, value: string): void {
  localStorage.setItem(
    btoa(encodeURIComponent(name)),
    btoa(encodeURIComponent(value))
  );
}

function removeItemStorage(name: string): void {
  if (isLocalOrSessionStorage()) {
    removeItemLocalStorage(name);
  } else {
    removeItemSessionStorage(name);
  }
}

function removeItemLocalStorage(name: string): void {
  localStorage.removeItem(btoa(encodeURIComponent(name)));
}
function removeItemSessionStorage(name: string): void {
  sessionStorage.removeItem(btoa(encodeURIComponent(name)));
}
function removeAllStorage(): void {
  sessionStorage.clear();
  localStorage.clear();
}
export {
  getItemLocalStorage,
  getItemSessionStorage,
  getItemStorage,
  removeAllStorage,
  removeItemLocalStorage,
  removeItemSessionStorage,
  removeItemStorage,
  setItemLocalStorage,
  setItemSessionStorage,
  setItemStorage
};

